// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"2df3eec1","462":"5956741d"}[chunkId] + ".chunk.js";
};